function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.-Kopsavilkums",
  transform: "translate(-30.000000, -110.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wallet",
  transform: "translate(0.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(30.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon-base",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,1 C19.0528636,1 19.9180289,1.81730785 19.994505,2.85093266 L20,3 L20,5 C21.0528636,5 21.9180289,5.81730785 21.994505,6.85093266 L22,7 L22,19 C22,20.0528636 21.1826921,20.9180289 20.1490673,20.994505 L20,21 L3,21 C1.83558621,21 0.12302497,20.2551534 0.00630185739,18.2227132 L0,18 L0,4 C0,2.40507143 1.25157398,1.09653571 2.82401157,1.00510323 L3,1 L18,1 Z M2,6.815 L2,18 C2,18.7546875 2.48339844,18.9626953 2.92449951,18.995636 L3.012,19 L20,19 L20,7 L3,7 C2.7176,7 2.448,6.95392 2.190688,6.877632 L2,6.815 Z M18,10 L18,16 L16,16 L16,10 L18,10 Z M18,3 L3,3 C2.448,3 2,3.449 2,4 C2,4.51164286 2.38628571,4.93533673 2.88343149,4.99325401 L3,5 L18,5 L18,3 Z",
  id: "icon",
  fill: "#667380",
  fillRule: "nonzero"
})))));

function SvgIcSidenavWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E86DFC96-BC65-465A-9786-2B471C67E3DA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidenavWallet);
export default __webpack_public_path__ + "static/media/ic-sidenav-wallet.19658288.svg";
export { ForwardRef as ReactComponent };